import type { SliderProps } from '@change/ds-forms';

import { useMembershipModalState } from '../../../../modalContext';

type Result = ModelHookResult<
	{
		sliderLayout?: SliderProps['layout'];
	},
	Record<string, never>
>;

export function useAmountSelector(): Result {
	const [{ sliderConfig }] = useMembershipModalState();

	return {
		data: { sliderLayout: sliderConfig.sliderLayout },
		actions: {},
	};
}
